import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import { createNamespacedHelpers } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapDealerState = createNamespacedHelpers('dealer').mapState

var mixin = {
  components: {
    'vue-google-autocomplete': VueGoogleAutocomplete,
    'error-display-component': ErrorDisplayComponent
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    ...mapUserGetters(['currentUser']),
    ...mapDealerState(['currentDealer'])
  },
  methods: {
    onNewContactBuyer: function (newBuyerContact) {
      var found = false
      for (var i = 0; i < this.contacts.length; i++) {
        var contact = this.contacts[i]
        if (contact.id !== newBuyerContact.id) {
          if (contact.selectedReceivesBuyersOrder !== null && contact.selectedReceivesBuyersOrder.name === 'Yes') {
            found = true
          }
          contact.selectedReceivesBuyersOrder = { id: 1, name: 'No', ico: 'fas fa-times has-text-danger' }
          contact.key = this.$uuid.v4()
        }
      }

      if (found) {
        this.showToast(newBuyerContact.firstName + ' ' + newBuyerContact.lastName + ' has been set as the contact to receive paperwork to buy a car from us')
      }
    },
    onNewContactSeller: function (newSellerContact) {
      var found = false
      for (var i = 0; i < this.contacts.length; i++) {
        var contact = this.contacts[i]
        if (contact.id !== newSellerContact.id) {
          if (contact.selectedReceivesSellersOrder !== null && contact.selectedReceivesSellersOrder.name === 'Yes') {
            found = true
          }
          contact.selectedReceivesSellersOrder = { id: 1, name: 'No', ico: 'fas fa-times has-text-danger' }
          contact.key = this.$uuid.v4()
        }
      }

      if (found) {
        this.showToast(newSellerContact.firstName + ' ' + newSellerContact.lastName + ' has been set as the contact to receive paperwork to sell a car to us')
      }
    },
    saveContact: function (supplierModel) {
      this.contacts.forEach(function (item) {
        var contact = {
          id: isNaN(item.id) ? 0 : item.id,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          mobile: item.mobile,
          receivesBuyersOrder: item.selectedReceivesBuyersOrder.id === 0,
          receivesSellersOrder: item.selectedReceivesSellersOrder.id === 0,
          receivesPaymentAndTitle: item.selectedReceivesPaymentAndTitle.id === 0,
          isPrimary: item.selectedIsPrimary.id === 0,
          status: item.selectedActiveStatus.id === 0 ? 'Active' : 'InActive'
        }

        supplierModel.contacts.push(contact)
      }, this)
    },
    addContact: function (isFirstContact) {
      var config = {
        sectionId: this.contacts.length + 100
      }

      var contact = this.createGenericContact(isFirstContact)
      contact.config = config
      this.contacts.push(contact)
    },
    removeContact (contactToRemove) {
      const indexToDelete = this.contacts.findIndex((x) => x.id === contactToRemove.id)
      this.contacts.splice(indexToDelete, 1)
    },
    createGenericContact (isFirstContact) {
      return {
        id: this.$uuid.v4(),
        key: this.$uuid.v4(),
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        receivesBuyersOrder: 0,
        receivesSellersOrder: 0,
        receivesPaymentAndTitle: 0,
        isPrimary: 0,
        selectedReceivesBuyersOrder: this.definedTypes.fillTypes.options.find((x) => x.id === (isFirstContact ? 0 : 1)),
        selectedReceivesSellersOrder: this.definedTypes.fillTypes.options.find((x) => x.id === (isFirstContact ? 0 : 1)),
        selectedReceivesPaymentAndTitle: this.definedTypes.fillTypes.options.find((x) => x.id === (isFirstContact ? 0 : 1)),
        selectedIsPrimary: this.definedTypes.fillTypes.options.find((x) => x.id === (isFirstContact ? 0 : 1)),
        selectedActiveStatus: this.definedTypes.fillTypes.options.find((x) => x.id === 0)
      }
    },
    showToast (message) {
      this.$buefy.toast.open(
        {
          duration: 2500,
          message: message,
          position: 'is-top',
          type: 'is-info'
        })
    },
    onAutoSelectPrimaryContact (updatedContact) {
      var newPrimary = this.contacts.find((x) => x.selectedIsPrimary.name === 'No' && x.selectedActiveStatus.name === 'Yes' && x.id !== updatedContact.id)
      if (newPrimary) {
        newPrimary.selectedIsPrimary = this.definedTypes.fillTypes.options.find(x => x.id === this.definedTypes.fillTypes.Yes)
        newPrimary.key = this.$uuid.v4()
        this.showToast(newPrimary.firstName + ' ' + newPrimary.lastName + ' has been set as the primary contact')
      }
    }
  },
  watch: {
    name: function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.name = titleCaseVersion
      }
    },
    firstName: function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.firstName = titleCaseVersion
      }
    },
    lastName: function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.lastName = titleCaseVersion
      }
    },
    'currentSupplier.name': function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.currentSupplier.name = titleCaseVersion
      }
    },
    'currentSupplier.firstName': function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.currentSupplier.firstName = titleCaseVersion
      }
    },
    'currentSupplier.lastName': function (newValue, oldValue) {
      const titleCaseVersion = this.$toTitleCase(newValue)
      if (titleCaseVersion !== newValue) {
        this.currentSupplier.lastName = titleCaseVersion
      }
    }
  }
}

export default mixin
